module.exports = __webpack_public_path__ + "static/media/Emotes-Fineline.a5b35590.png";